var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.179 6.39232L23.4821 23.8267C23.2032 25.0572 22.4759 25.3634 21.4423 24.7837L15.8095 20.6329L13.0915 23.247C12.7907 23.5478 12.5391 23.7993 11.9595 23.7993L12.3641 18.0626L22.804 8.62904C23.2579 8.22435 22.7056 8.00013 22.0985 8.40482L9.19227 16.5314L3.63602 14.7923C2.42743 14.415 2.40555 13.5837 3.88758 13.004L25.6204 4.63138C26.6266 4.25404 27.5071 4.8556 27.179 6.39232Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.0e582f5c872bb29153dd92c2904d706b.svg";
export { ForwardRef as ReactComponent };